export default __webpack_public_path__ + "static/3-6b2846f8166f7a7c86477cd6c306b4b4.png";